import { makeStyles } from "tss-react/mui";
//
const useStyles = makeStyles()(() => ({
  closeIcon: {
    position: "absolute",
    top: "10px",
    right: "10px",
    height: "25px",
    width: "25px",
    cursor: "pointer",
  },
  arrowBackIcon: {
    position: "absolute",
    top: "10px",
    left: "10px",
    height: "25px",
    width: "25px",
    cursor: "pointer",
  },
}));
export default useStyles;
